const CART_ACTION = {
  ADD_CART_ITEMS: 'ADD_CART_ITEMS',
  ADD_CART_ITEM: 'ADD_CART_ITEM',
  UPDATE_CART_ITEM_COUNT: 'UPDATE_CART_ITEM_COUNT',
};
export default CART_ACTION;
